import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITable from 'UIComponents/table/UITable';
import UnifiedEventPropertyTableRow from 'flow-doctor-lib/components/timeline/UnifiedEventPropertyTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnifiedEventPropertyTable = ({
  properties,
  propertyDefinitions
}) => {
  return /*#__PURE__*/_jsxs(UITable, {
    condensed: true,
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.unifiedEventHistory.properties.name"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.unifiedEventHistory.properties.value"
          })
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: Object.values(properties).map(property => {
        const propertyDef = propertyDefinitions[property.name];
        return /*#__PURE__*/_jsx(UnifiedEventPropertyTableRow, {
          property: property,
          propertyDef: propertyDef
        }, property.name);
      })
    })]
  });
};
export default UnifiedEventPropertyTable;